// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/_css-loader@6.11.0@css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/_css-loader@6.11.0@css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html,\nbody .app {\n  color: #333333;\n  font-family: Arial, Helvetica, \"STHeiti STXihei\", \"Microsoft YaHei\", Tohoma, sans-serif;\n  background-color: #f8f8f8;\n}\n\n.app-container {\n  padding-bottom: 13.333333vw;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
